import { render, staticRenderFns } from "./departmentList.vue?vue&type=template&id=6be6841b&scoped=true&lang=html&"
import script from "./departmentList.vue?vue&type=script&lang=js&"
export * from "./departmentList.vue?vue&type=script&lang=js&"
import style0 from "./departmentList.vue?vue&type=style&index=0&id=6be6841b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be6841b",
  null
  
)

export default component.exports